import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { IdentificationTagSearchCriteria } from './models/IdentificationTagSearchCriteria';
import { IdentificationTagDto } from './models/IdentificationTagDto';
import { SelectValueLabel } from 'common/types/SelectValueLabel';

class IdentificationTagsService {
    public getList(criteria: IdentificationTagSearchCriteria) {
        return Http.get<Paged<IdentificationTagDto>>('identificationtags', criteria);
    }

    public getById(id: string) {
        return Http.get<IdentificationTagDto>('identificationtags/' + id);
    }

    public getIdentificationTags(companyId: string) {
        return Http.get<SelectValueLabel[]>('identificationtags/getsimcards/' + companyId);
    }

    public create(model: IdentificationTagDto) {
        return Http.post<string>('identificationtags', model);
    }

    public update(model: IdentificationTagDto) {
        return Http.put<string>('identificationtags/' + model.id, model);
    }

    public remove(model: IdentificationTagDto) {
        return Http.put(`identificationtags/${model.id}/deactivate`, model);
    }
}

export default new IdentificationTagsService();
